// Bulgarian

export default {

  component: {
    jobAdList: {
      title: 'Отворени работни позиции',
      jobs: 'работни места',
      noJobAds: 'В момента няма отворени работни позиции.',
    },

    jobAdCard: {
      openUntil: date => `отворено до ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Благодарим Ви.',
      readyInfo: 'Вашата кандидатура беше получена и работодателят ще се свърже с Вас скоро.',
      luck: 'Успех!',
    },

    jobAdSeeYou: {
      title: 'Благодарим Ви.',
      description: 'Вашата кандидатура е запаметена и ние Ви изпратихме линк, за да продължите с кандидатстването по-късно.',
    },

    unpublished: {
      title: 'Непубликувана',
      info: 'Обявата за работа още не е публикувана.',
    },
  },

  page: {},

}
